<h1 mat-dialog-title>{{'poActivityOverview.newOrderDialogTitle' | translate}}</h1>
<div mat-dialog-content>
    <div>{{'poActivityOverview.newOrderDialogMsg' | translate}}</div>
    <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>


